import React, {useEffect} from 'react';
import "../assets/Campaigns.scss";
import {Grid} from "@deere/fuel-react";
import {useOktaAuth} from '@okta/okta-react';
import {CampaignTitleCard} from "./CampaignTitleCard";
import {CampaignCriteriaCard} from "./CampaignCriteriaCard";
import {CampaignStakeholderCard} from './CampaignStakeholderCard';
import PropTypes from "prop-types";

export const CampaignReview = ({currentData, control, onEdit, onSelectStep}) => {
    const {authState} = useOktaAuth();

    const onHandleEdit = (stepId) => {
        onEdit(stepId)
    }

    useEffect(() => {
        onSelectStep(3);
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <Grid container>
            <CampaignTitleCard currentData={currentData} control={control} onHandleEdit={onHandleEdit}/>
            <CampaignCriteriaCard currentData={currentData} control={control} onHandleEdit={onHandleEdit}/>
            <CampaignStakeholderCard currentData={currentData} onHandleEdit={onHandleEdit}/>
        </Grid>
    )
}

CampaignReview.propTypes = {
  control: PropTypes.any,
  currentData: PropTypes.any,
  onEdit: PropTypes.func,
  onSelectStep: PropTypes.func
}
